<template>
  <div class="form-group">
    <label class="form-label">{{ label }}</label>
    <div v-if="tags.length > 0" class="tags">
      <tag
        v-for="(tag, index) in tags"
        :key="tag"
        :tag="tag"
        :editable="!disabled"
        @delete="removeTag(index)"
      ></tag>
    </div>
    <div class="form-group">
      <auto-complete
        v-if="!disabled"
        v-model="inputText"
        :items="suggestions"
        :placement="placement"
        display-attribute="value"
        value-attribute="id"
        @select="addTag"
      />
    </div>
  </div>
</template>
<script>
import AutoComplete from "@/components/common/forms/AutoComplete.vue";
import Tag from "./Tag.vue";

const NEW_TAG_ID = "__new";

const addTag = function(item) {
  let val;
  if (item.id === NEW_TAG_ID) {
    val = this.inputText.trim();
  } else {
    val = item.value.trim();
  }

  const tags = [...this.tags];
  if (val.length > 0 && !tags.some((t) => t === val)) {
    tags.push(val);
    this.tags = tags;
  }

  this.logDebug("Added tag.", { tag: item });
  this.inputText = "";
};

const removeTag = function(index) {
  const tags = [...this.tags];
  tags.splice(index, 1);
  this.tags = tags;

  this.logDebug("Removed tag.");
};

export default {
  components: { Tag, AutoComplete },
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "Tags",
    },
    existingTags: {
      type: Array,
      required: false,
      default: function() {
        return [];
      },
    },
    listPosition: {
      type: String,
      required: false,
      default: "below",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function() {
    return {
      inputText: "",
    };
  },
  computed: {
    tags: {
      get: function() {
        return this.modelValue;
      },
      set: function(value) {
        this.$emit("update:modelValue", value);
      },
    },
    placement: function() {
      return this.listPosition === "above" ? "top-start" : "bottom-start";
    },
    suggestions: function() {
      const items = [];
      const lowerQuery = this.inputText.toLowerCase();
      const hasExactMatch = this.existingTags.some(
        (t) => t.value === this.inputText
      );

      if (!hasExactMatch) {
        items.push({
          id: NEW_TAG_ID,
          value: `[Add as '${this.inputText}' new tag]`,
        });
      }

      const filtered = this.existingTags.filter((t) =>
        t.value.toLowerCase().includes(lowerQuery)
      );

      return [...items, ...filtered];
    },
  },
  methods: {
    addTag,
    removeTag,
  },
  emits: ["update:modelValue"],
};
</script>
<style lang="scss" scoped>
.tags {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
</style>
